import {
  FalLogo,
  Mosoq,
  ProfileImg,
  ProfileImg2,
  Thumbnail1,
  Thumbnail2,
  Thumbnail3,
} from "../components/styled/AllImages";

export const ProvinceList = [
  {
    label: "Riyadh",
    value: 1,
  },
  {
    label: "Jeddah",
    value: 2,
  },
];
export const cityList = [
  {
    label: "Riyadh",
    value: 1,
  },
  {
    label: "Jeddah",
    value: 2,
  },
];
export const OperateList = [
  {
    label: "SaudiArabia",
    value: 1,
  },
];
export const SpecializationList = [
  {
    label: "Specialization",
    value: 1,
  },
];
export const TimeListFrom = [
  {
    label: "12:00 AM",
    value: 1,
  },
  {
    label: "1:00 AM",
    value: 2,
  },
  {
    label: "2:00 AM",
    value: 3,
  },
  {
    label: "3:00 AM",
    value: 4,
  },
  {
    label: "4:00 AM",
    value: 5,
  },
  {
    label: "5:00 AM",
    value: 6,
  },
  {
    label: "6:00 AM",
    value: 7,
  },
  {
    label: "7:00 AM",
    value: 8,
  },
  {
    label: "8:00 AM",
    value: 9,
  },
  {
    label: "9:00 AM",
    value: 10,
  },
  {
    label: "10:00 AM",
    value: 11,
  },
  {
    label: "11:00 AM",
    value: 12,
  },
  {
    label: "12:00 PM",
    value: 13,
  },
  {
    label: "1:00 PM",
    value: 14,
  },
  {
    label: "2:00 PM",
    value: 15,
  },
  {
    label: "3:00 PM",
    value: 16,
  },
  {
    label: "4:00 PM",
    value: 17,
  },
  {
    label: "5:00 PM",
    value: 18,
  },
  {
    label: "6:00 PM",
    value: 19,
  },
  {
    label: "7:00 PM",
    value: 20,
  },
  {
    label: "8:00 PM",
    value: 21,
  },
  {
    label: "9:00 PM",
    value: 22,
  },
  {
    label: "10:00 PM",
    value: 23,
  },
  {
    label: "11:00 PM",
    value: 24,
  },
];
export const TimeListTo = [
  {
    label: "12:00 AM",
    value: 1,
  },
  {
    label: "1:00 AM",
    value: 2,
  },
  {
    label: "2:00 AM",
    value: 3,
  },
  {
    label: "3:00 AM",
    value: 4,
  },
  {
    label: "4:00 AM",
    value: 5,
  },
  {
    label: "5:00 AM",
    value: 6,
  },
  {
    label: "6:00 AM",
    value: 7,
  },
  {
    label: "7:00 AM",
    value: 8,
  },
  {
    label: "8:00 AM",
    value: 9,
  },
  {
    label: "9:00 AM",
    value: 10,
  },
  {
    label: "10:00 AM",
    value: 11,
  },
  {
    label: "11:00 AM",
    value: 12,
  },
  {
    label: "12:00 PM",
    value: 13,
  },
  {
    label: "1:00 PM",
    value: 14,
  },
  {
    label: "2:00 PM",
    value: 15,
  },
  {
    label: "3:00 PM",
    value: 16,
  },
  {
    label: "4:00 PM",
    value: 17,
  },
  {
    label: "5:00 PM",
    value: 18,
  },
  {
    label: "6:00 PM",
    value: 19,
  },
  {
    label: "7:00 PM",
    value: 20,
  },
  {
    label: "8:00 PM",
    value: 21,
  },
  {
    label: "9:00 PM",
    value: 22,
  },
  {
    label: "10:00 PM",
    value: 23,
  },
  {
    label: "11:00 PM",
    value: 24,
  },
];

export const SuggestedList = [
  {
    id: 1,
    suggAvatar: ProfileImg2,
    suggName: "RobertFox",
    suggRole: "RealEstateBrokerage",
    suggFollow: "Follow",
  },
  {
    id: 2,
    suggAvatar: ProfileImg2,
    suggName: "RobertFox",
    suggRole: "RealEstateBrokerage",
    suggFollow: "Follow",
  },
  {
    id: 3,
    suggAvatar: ProfileImg2,
    suggName: "RobertFox",
    suggRole: "RealEstateBrokerage",
    suggFollow: "Follow",
  },
  {
    id: 4,
    suggAvatar: ProfileImg2,
    suggName: "RobertFox",
    suggRole: "RealEstateBrokerage",
    suggFollow: "Follow",
  },
];

export const NotificationsListArray = [
  {
    userImg: ProfileImg,
    userName: "Marvin McKinney",
    status: "hasFollowedyou",
    messageTime: "minutesago",
  },
  {
    userImg: ProfileImg,
    userName: "Darrell Steward",
    status: "hascommentedonyourpost",
    messageTime: "minutesago",
  },
  {
    userImg: ProfileImg,
    userName: "Marvin McKinney",
    status: "hasFollowedyou",
    messageTime: "minutesago",
  },
  {
    userImg: ProfileImg,
    userName: "Darrell Steward",
    status: "hascommentedonyourpost",
    messageTime: "minutesago",
  },
];
export const UserProfileLogos = [
  {
    logo: <img src={FalLogo} alt="fal logo" />,
  },
  {
    logo: <img src={Mosoq} alt="mosoq logo" />,
  },
];
// Array of days
export const Cities = [
  {
    city: "Jeddah",
  },
  {
    city: "Tabuk",
  },
  {
    city: "AlKharj",
  },
  {
    city: "Dammam",
  },
  {
    city: "Riyadh",
  },
];
export const PropertiesList = [
  {
    sliderImages: [
      {
        img: Thumbnail1,
      },
      {
        img: Thumbnail2,
      },
      {
        img: Thumbnail3,
      },
    ],

    status: "Sold",
    title: "EliteHavenResidences",
    city: "Riyadh",
    district: "AlMalqaDistrict",
    platform: "Dalali",
    adNumber: "95685471",
  },
  {
    sliderImages: [
      {
        img: Thumbnail1,
      },
      {
        img: Thumbnail2,
      },
      {
        img: Thumbnail3,
      },
    ],
    status: "Sold",
    title: "EliteHavenResidences",
    city: "Riyadh",
    district: "AlMalqaDistrict",
    platform: "Dalali",
    adNumber: "95685471",
  },
  {
    sliderImages: [
      {
        img: Thumbnail1,
      },
      {
        img: Thumbnail2,
      },
      {
        img: Thumbnail3,
      },
    ],
    status: "available",
    title: "EliteHavenResidences",
    city: "Riyadh",
    district: "AlMalqaDistrict",
    platform: "Dalali",
    adNumber: "95685471",
  },
  {
    sliderImages: [
      {
        img: Thumbnail1,
      },
      {
        img: Thumbnail2,
      },
      {
        img: Thumbnail3,
      },
    ],
    status: "Sold",
    title: "EliteHavenResidences",
    city: "Riyadh",
    district: "AlMalqaDistrict",
    platform: "Dalali",
    adNumber: "95685471",
  },
  {
    sliderImages: [
      {
        img: Thumbnail1,
      },
      {
        img: Thumbnail2,
      },
      {
        img: Thumbnail3,
      },
    ],
    status: "Sold",
    title: "EliteHavenResidences",
    city: "Riyadh",
    district: "AlMalqaDistrict",
    platform: "Dalali",
    adNumber: "95685471",
  },
  {
    sliderImages: [
      {
        img: Thumbnail1,
      },
      {
        img: Thumbnail2,
      },
      {
        img: Thumbnail3,
      },
    ],
    status: "Sold",
    title: "EliteHavenResidences",
    city: "Riyadh",
    district: "AlMalqaDistrict",
    platform: "Dalali",
    adNumber: "95685471",
  },
  {
    sliderImages: [
      {
        img: Thumbnail1,
      },
      {
        img: Thumbnail2,
      },
      {
        img: Thumbnail3,
      },
    ],
    status: "Sold",
    title: "EliteHavenResidences",
    city: "Riyadh",
    district: "AlMalqaDistrict",
    platform: "Dalali",
    adNumber: "95685471",
  },
  {
    sliderImages: [
      {
        img: Thumbnail1,
      },
      {
        img: Thumbnail2,
      },
      {
        img: Thumbnail3,
      },
    ],
    status: "Sold",
    title: "EliteHavenResidences",
    city: "Riyadh",
    district: "AlMalqaDistrict",
    platform: "Dalali",
    adNumber: "95685471",
  },
  {
    sliderImages: [
      {
        img: Thumbnail1,
      },
      {
        img: Thumbnail2,
      },
      {
        img: Thumbnail3,
      },
    ],
    status: "Sold",
    title: "EliteHavenResidences",
    city: "Riyadh",
    district: "AlMalqaDistrict",
    platform: "Dalali",
    adNumber: "95685471",
  },
  {
    sliderImages: [
      {
        img: Thumbnail1,
      },
      {
        img: Thumbnail2,
      },
      {
        img: Thumbnail3,
      },
    ],
    status: "Sold",
    title: "EliteHavenResidences",
    city: "Riyadh",
    district: "AlMalqaDistrict",
    platform: "Dalali",
    adNumber: "95685471",
  },
  {
    sliderImages: [
      {
        img: Thumbnail1,
      },
      {
        img: Thumbnail2,
      },
      {
        img: Thumbnail3,
      },
    ],
    status: "Sold",
    title: "EliteHavenResidences",
    city: "Riyadh",
    district: "AlMalqaDistrict",
    platform: "Dalali",
    adNumber: "95685471",
  },
  {
    sliderImages: [
      {
        img: Thumbnail1,
      },
      {
        img: Thumbnail2,
      },
      {
        img: Thumbnail3,
      },
    ],
    status: "Sold",
    title: "EliteHavenResidences",
    city: "Riyadh",
    district: "AlMalqaDistrict",
    platform: "Dalali",
    adNumber: "95685471",
  },
];
export const NeighbourHood = [
  {
    label: "Riyadh",
    value: 1,
  },
  {
    label: "Jeddah",
    value: 2,
  },
];
export const AdPlatform = [
  {
    label: "Platform 1",
    value: 1,
  },
  {
    label: "Platform 2",
    value: 2,
  },
];

export const imageGalleryData = [
  {
    src: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    alt: "Modern house exterior",
  },
  {
    src: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2053&q=80",
    alt: "Modern house interior",
  },
  {
    src: "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    alt: "Modern house pool",
  },
  {
    src: "https://images.unsplash.com/photo-1600607688969-a5bfcd646154?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    alt: "Modern house bedroom",
  },
  {
    src: "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    alt: "Modern house pool",
  },
  {
    src: "https://images.unsplash.com/photo-1600607688969-a5bfcd646154?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    alt: "Modern house bedroom",
  },
];

export const videoGalleryData = [
  {
    src: "https://www.w3schools.com/html/mov_bbb.mp4",
    thumbnail:
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    title: "House Tour Video 1",
  },
  {
    src: "https://www.w3schools.com/html/movie.mp4",
    thumbnail:
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    title: "House Tour Video 2",
  },
  {
    src: "https://www.w3schools.com/html/mov_bbb.mp4",
    thumbnail:
      "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    title: "House Tour Video 3",
  },
  {
    src: "https://www.w3schools.com/html/mov_bbb.mp4",
    thumbnail:
      "https://images.unsplash.com/photo-1600607688969-a5bfcd646154?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    title: "House Tour Video 5",
  },
  {
    src: "https://www.w3schools.com/html/mov_bbb.mp4",
    thumbnail:
      "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    title: "House Tour Video 3",
  },
  {
    src: "https://www.w3schools.com/html/mov_bbb.mp4",
    thumbnail:
      "https://images.unsplash.com/photo-1600607688969-a5bfcd646154?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
    title: "House Tour Video 5",
  },
];
